import React from "react";
import clsx from "clsx";

import styles from "./ToolTip.module.scss";

export interface TooltipProps {
  children: React.ReactNode;
  content: string;
  placement?: "bottom" | "right";
}

const ToolTip = (props: TooltipProps) => {
  return (
    <div
      className={clsx(
        styles.tooltipContainer,
        props.placement === "right" && styles.placementRight,
      )}
      data-tooltip={props.content}
    >
      {props.children}
    </div>
  );
};

export default ToolTip;
